import { isOwner, isJoined, isAdmin } from './MemberRole';
import { memberWrapper, isAnonymous, isGroupMember } from './Member';
var GroupMember = /** @class */ (function () {
    function GroupMember(member) {
        this.member = memberWrapper(member);
    }
    GroupMember.prototype.getImageUrl = function () {
        return this.member.imageUrl;
    };
    GroupMember.prototype.getName = function () {
        return this.member.name.nick;
    };
    GroupMember.prototype.getId = function () {
        return this.member.siteMemberId;
    };
    GroupMember.prototype.isAnonymous = function () {
        return isAnonymous(this.member);
    };
    /**
     * the member's relationship with the group !== NONE
     * @return {boolean}
     */
    GroupMember.prototype.relatedToGroup = function () {
        return isGroupMember(this.member);
    };
    /**
     * RelationshipWithGroup == JOINED
     * @return {boolean}
     */
    GroupMember.prototype.isJoined = function () {
        return isJoined(this.member);
    };
    GroupMember.prototype.isOwner = function (group) {
        return isOwner(group, this.member);
    };
    GroupMember.prototype.isAdmin = function () {
        return isAdmin(this.member);
    };
    GroupMember.prototype.isMe = function (other) {
        return this.getId() === other.siteMemberId;
    };
    return GroupMember;
}());
export { GroupMember };
//# sourceMappingURL=GroupMember.js.map